// import './main-app.js';
import '../../local_modules/vessel-app-switcher/src/vessel-app-switcher.js'
import { registerServiceWorker } from '../../src/utils/reg-sw.js';

const isVesselOnCloud = (window)["appenv"].vesselOnCloud;
if (isVesselOnCloud) {
  console.log("*** Launching Cloud Vessel app ***");
  // register Service worker
  registerServiceWorker();
}
